import { render, staticRenderFns } from "./KPIInclusionGrid.vue?vue&type=template&id=12e48d89"
import script from "./KPIInclusionGrid.vue?vue&type=script&lang=js"
export * from "./KPIInclusionGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports